<page-header title="Register your business"></page-header>
<div class="editableBatchGrid">
  <form class="batch-panels" [formGroup]="form">
    <panels #panelGroup notShowBackground="true" startAt="1" (panelChanged)="panelChanged($event)">
      <panel label="Business Type" [form]="form.controls.businessType">
        <div class="cmn-container-width">
          <ng-template *ngTemplateOutlet="panelNavigation"></ng-template>
        </div>
      </panel>
      <panel label="Business Information" [form]="form.controls.businessInfoForm">
        <div class="cmn-container-width">
          <business-info formGroupName="businessInfoForm"></business-info>
          <ng-template *ngTemplateOutlet="panelNavigation"></ng-template>
        </div>
      </panel>
      <panel label="Personal Information" [form]="form.controls.personalInfo">
        <div class="cmn-container-width">
          <qp-personal-info formGroupName="personalInfo"></qp-personal-info>
          <ng-template *ngTemplateOutlet="panelNavigation"></ng-template>
        </div>
      </panel>
    </panels>
  </form>
</div>

<ng-template #panelNavigation>
  <div class="panel-navigation mt-50 mb-10">
    <button
      *ngIf="!(panelGroup.lastPanelActive$ | async)"
      [disabled]="currentForm.invalid"
      class="cmn-blue-btn"
      mat-raised-button
      color="primary"
      (click)="panelGroup.nextPanel()"
    >
      Next <span class="material-icons btn-arw">keyboard_arrow_right</span>
    </button>
    <button
      *ngIf="form.enabled && panelGroup.lastPanelActive$ | async"
      class="cmn-success-btn"
      mat-raised-button
      color="primary"
      (click)="submit()"
      [disabled]="form.invalid"
    >
      <span class="btn-circle-check mr-10">
        <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="9.5" cy="9.5" r="9" stroke="#DFEAEA" />
          <path
            d="M6.33337 9.49967C7.25699 10.4233 9.10421 12.2705 9.10421 12.2705L13.0625 6.33301"
            stroke="#DFEAEA"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </span>
      Complete Registration
    </button>
  </div>
</ng-template>
